var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-circle",
    "data-name": "Icon awesome-user-circle",
    d: "M25,.563a25,25,0,1,0,25,25A25,25,0,0,0,25,.563Zm0,9.677a8.871,8.871,0,1,1-8.871,8.871A8.871,8.871,0,0,1,25,10.24Zm0,34.677a19.317,19.317,0,0,1-14.768-6.875,11.239,11.239,0,0,1,9.929-6.028,2.467,2.467,0,0,1,.716.111,13.347,13.347,0,0,0,4.123.7,13.3,13.3,0,0,0,4.123-.7,2.466,2.466,0,0,1,.716-.111,11.239,11.239,0,0,1,9.929,6.028A19.317,19.317,0,0,1,25,44.917Z",
    transform: "translate(0 -0.563)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFill);
export default __webpack_public_path__ + "static/media/user-fill.fbdddc5223d2bd239fb8b28cb63d8a89.svg";
export { ForwardRef as ReactComponent };